import { render, staticRenderFns } from "./ClaimViewer.vue?vue&type=template&id=70b632dd&scoped=true&"
import script from "./ClaimViewer.vue?vue&type=script&lang=js&"
export * from "./ClaimViewer.vue?vue&type=script&lang=js&"
import style0 from "./ClaimViewer.vue?vue&type=style&index=0&id=70b632dd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b632dd",
  null
  
)

export default component.exports